import React from 'react';
import { translate } from 'react-i18next';
import { Text } from 'react-native';
import PropTypes from 'prop-types';

import { styles } from './Styles';

const InviteDescriptionWithPartnerNames = ({
  t,
  firstnames
}) => {
  const firstnamesElements = firstnames.map((firstname, index) => {
    const isLastNameInList = (index === firstnames.length - 1) && firstnames.length > 1;
    const isFirstNameInList = index === 0;
    return (
      <Text key={firstname}>
        {isLastNameInList &&
          <Text> and </Text>
        }
        {!isLastNameInList && !isFirstNameInList &&
          <Text>, </Text>
        }
        <Text key={firstname} style={styles.partnerName}>{firstname}</Text>
      </Text>
    );
  });

  return (
    <Text style={styles.description}>
      {firstnamesElements}
      <Text> {t('invitedToTrainOnThisDay', { count: firstnames.length })}</Text>
    </Text>
  );
}

InviteDescriptionWithPartnerNames.propTypes = {
  firstnames: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default translate(['bookings'], { wait: true })(InviteDescriptionWithPartnerNames);
